import axios from "axios"
import { useEffect, useState } from "react"
import { EMPLOYEES_API } from "../../../../Utilities/APIs"

function ResendInvite({employee, setShowModal, setShowResendSection, targetID}) {

  const [email, setEmail] = useState('')

  useEffect(() => {

    const config = {
      headers: {
        Authorization: `Bearer ${employee.token}`
      }
    }

    async function fetchAndSetEmail() {
      const {data} = await axios.get(EMPLOYEES_API + 'getSingleInvite/' + targetID, config)
      setEmail(data.email)
    }

    fetchAndSetEmail()

  }, [targetID, employee.token])

  async function handleResend() {

      const config = {
        headers: {
          Authorization: `Bearer ${employee.token}`
        }
      }
      
      const itemData = {email}
      
      const response = await axios.post(EMPLOYEES_API + 'employeeinvite', itemData, config)

      if (response) {
        setEmail('')

        setShowResendSection(false);
        setShowModal(false);
    }
  }

  return (
    <div className='modal_delete_content'>
      
      <p>Are you sure you want to resend invite to {email ? email : ''}?</p>

      <div className="modal_group_buttons">
        <button
          className="delete" onClick={() => {
            handleResend()
          }}
        >Resend</button>

        <button className="cancel" onClick={() => {
          setShowModal(false);
          setShowResendSection(false);
        }}>Cancel</button>
      </div>

    </div>
  )
}

export default ResendInvite